export const TIMEOUTS = {
  RESPONSE_TIMEOUT: 5000,
  DEADLINE_TIMEOUT: 10000
}
